module.exports = __webpack_public_path__ + "img/section3_pic1.26bc00b9.png";